
const pcIntroduceRoute = {
  path: '/pc-introduce',
  name: 'pcIntroduce',
  component: () => import('@/views/introduce/pc-introduce'),
  meta: {hidden: true}
}
export default pcIntroduceRoute



// WEBPACK FOOTER //
// ./src/router/modules/pcIntroduce.js